import { call, put, takeLatest } from "redux-saga/effects";
import { studentAPI } from "../../../services/student/index"
import { fetchAllCourses, FETCH_ALL_COURSES} from "../../actions/student.action"

function* handleFetchAllCourses(action) {
  try {
    const { data : resData} = yield call(studentAPI.fetchAllCourses, action.payload);
    //extract the data here     
    yield put(fetchAllCourses.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(fetchAllCourses.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* fetchAllCoursesSaga() {
  yield takeLatest(FETCH_ALL_COURSES.REQUEST, handleFetchAllCourses);
}

export default fetchAllCoursesSaga;
